import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useReportId } from "@ryde/redux";
import {
  getSpecificSearchPatterMatch,
  reportFiltersWithValuesAF,
  rideFilterSearchAtom,
} from "@ryde/shared";

export const useFiltersActiveStateReports = () => {
  const { reportId } = useReportId();
  const searchText = useRecoilValue(rideFilterSearchAtom(reportId));
  const activeFilters = useRecoilValue(reportFiltersWithValuesAF(reportId));
  const isSearchText = getSpecificSearchPatterMatch(searchText)?.[1] ?? "";

  const isAnyFilterActive = useMemo(
    () =>
      (activeFilters !== undefined &&
        Boolean(Object.keys(activeFilters).length)) ||
      Boolean(isSearchText),
    [activeFilters, isSearchText],
  );
  return { isAnyFilterActive };
};
